export default class StringUtil {
  static capitalize(str: string) {
    return str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substring(1),
    );
  }
}
